module.exports = __webpack_public_path__ + "img/signs15.aadf3229.jpg";